import { Cog, FlaskConical, Globe, Landmark, Palette, type LucideIcon } from 'lucide-react';
import type { Categorie } from '../data/types';

export const CATEGORIE_ICOON: Record<Categorie, LucideIcon> = {
  kunst: Palette,
  geschiedenis: Landmark,
  wetenschap: FlaskConical,
  techniek: Cog,
  cultuur: Globe,
};
